import { httpCreate } from './http';

const http = httpCreate('/srv/videoHighlights');

export const videoHighlights = {
	//获取用户媒体库视频列表
	getUserVideoList(activityId, params) {
		return http.get(`/userVideo/${activityId}`, { params });
	},
	//获取视频集锦中视频列表
	getPCVideoList(activityId, menuId, params) {
		return http.get(`/${activityId}/${menuId}`, { params });
	},
	//添加视频集锦
	addVideo(activityId, menuId, ids) {
		return http.post(`/${activityId}/${menuId}`, ids);
	},
	//删除视频
	delVideo(id) {
		return http.delete(`/${id}`);
	},
};
